import React, {Component} from 'react';
import {alertLabels, labels, messages} from "../../util/constants";
import FontAwesome from 'react-fontawesome';
import {Input, Button, Label} from 'reactstrap';
import './login.css';
import {clearAlertOnRedux, setAlertOnRedux, setTokenUserStorage,setUserLoggedOnRedux} from "../../actions";
import {routes} from "../../util/config";
import httpHttpsRequest from '../../util/http-request/request';
import { loginOptions } from '../../util/optionsRequest';

class Login extends Component{
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: '',
            password: ''
        };
    }

    validateFields = () => {
        clearAlertOnRedux();
        this.state.user = this.state.user.trim();
        if (this.state.user.length === 0) {
            setAlertOnRedux(true, alertLabels.iconError, messages.userEmptyError,alertLabels.alertDanger);
            return false;
        }
        if (this.state.password.length === 0) {
            setAlertOnRedux(true, alertLabels.iconError, messages.passwordEmptyError,alertLabels.alertDanger);
            return false;
        }
        return true;
    };

    validLogin = () => {
        if (this.validateFields() === false) {
            return;
        }
        let params = {
            id_user: this.state.user.toUpperCase(),
            user_pass: this.state.password
        };

        let http = new httpHttpsRequest(loginOptions);
        http.addRequestBody(params);

        http.makeRequest().then((data)=>{this.loginSuccess(data)})
            .catch((data)=>{this.loginError(data);});
    };

    loginSuccess = (response) => {
        let logged = false;

        if(response != null){
            let data = JSON.parse(response);
            if(data.token != null){
                clearAlertOnRedux();
                logged = true;
                setUserLoggedOnRedux(this.state.user,data.user_name.toString(),data.token.toString());
                setTokenUserStorage(data.token.toString(),this.state.user,data.user_name.toString());
                //redirect to home
                this.props.history.push(routes.home);
            }

        }
        if (!logged) {
           setAlertOnRedux(true, alertLabels.iconError, messages.loginError,alertLabels.alertDanger);
        }
    };

    loginError = (response) => {
        try {
            let data = JSON.parse(response.body);
           setAlertOnRedux(true, alertLabels.iconError, data.message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    updateUserValue = (evt) => {
        this.setState({
            user: evt.target.value.toUpperCase()
        });
    };

    updatePasswordValue = (evt) => {
        this.setState({
            password: evt.target.value
        });
    };

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.validLogin()
        }
    };

    render(){
        return(
            <div className='container login' onKeyPress={this._handleKeyPress}>
                <h1 className='title'><FontAwesome name={'lock'}/>{'\u00A0'} {labels.login}</h1>

                <div className={'input-container'}>
                    <Label className='label-form' >{labels.insertUser}{labels.colon}</Label>
                    <Input className={'inputLogin'} placeholder={messages.registration}
                           value={this.state.user} onChange={evt => this.updateUserValue(evt)}/>

                    <Label className='label-form' >{labels.password}{labels.colon}</Label>
                    <Input className={'inputLogin'} placeholder={messages.password} type="password"
                           value={this.state.password} onChange={evt => this.updatePasswordValue(evt)}/>

                    <Button className={'button'}  color="primary" onClick={()=>this.validLogin()}>{labels.login}</Button>
                </div>

            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/containers/login/login.js